
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, styled, TextField, Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close';
import { useCallback, useEffect, useRef, useState } from 'react';
import useDigitInput from 'react-digit-input';

const getPassword = () => String(Math.floor(1000 + Math.random() * 9000))

const InputPassword = styled('input')({
	textAlign: 'center',
	fontSize: '23px',
	width: '50px',
	height: '50px',
	margin: '15px',
})

interface ConfirmBoxProps {
    onCancel: () => void,
	onConfirm: (title: string) => void,
	title: string
}
const ConfirmBox: React.FC<ConfirmBoxProps> = ({onConfirm, onCancel, title}) => {
    const [value, onChange] = useState('')
    const [password, setPassword] = useState(getPassword())
	const [isButtonDisabled, setIsButtonDisabled] = useState(true)
	
	const digits = useDigitInput({
		acceptedCharacters: /^[0-9]$/,
		length: 4,
		value,
		onChange,
	})

	const handleConfirm = useCallback(() => {
		setPassword(getPassword())
		onChange('')
		onConfirm(title)
	}, [title])

	const handleCancel = useCallback(() => {
		setPassword(getPassword())
		onChange('')
		onCancel()
	}, [])

	useEffect(() => {
		if (value === password && isButtonDisabled) {
			setIsButtonDisabled(false)
			return
		}
		if (value !== password && !isButtonDisabled) {
			setIsButtonDisabled(true)
			return
		}
	}, [value, password, isButtonDisabled])
    
	return (
		<Dialog open={title?.length > 0} maxWidth="xs" fullWidth onBackdropClick={handleCancel}>
			<DialogTitle>{title}</DialogTitle>
			<Box position="absolute" top={0} right={0}>
				<IconButton onClick={handleCancel}>
					<CloseIcon />
				</IconButton>
			</Box>
			<DialogContent>
				<Box display="flex" justifyContent="center">
					<Typography variant="h4">
						Enter
						<Typography component="span" fontWeight={800} fontSize={22} mx={1}>
							{password}
						</Typography>
						to confirm delete.
					</Typography>
				</Box>

				<Box display="flex" justifyContent="center">
					<InputPassword {...digits[0]} />
					<InputPassword {...digits[1]} />
					<InputPassword {...digits[2]} />
					<InputPassword {...digits[3]} />
				</Box>
			</DialogContent>
			<DialogActions>
				<Button color="primary" variant="contained" onClick={handleCancel}>
					Cancel
				</Button>
				<Button color="secondary" variant="outlined" onClick={handleConfirm} disabled={isButtonDisabled}>
					Confirm
				</Button>
			</DialogActions>
		</Dialog>
	)
}
  
  export default ConfirmBox;